/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Segment_Event_Group_User_Segments_LabelInputs */

const en_segment_event_group_user_segments_label = /** @type {(inputs: Segment_Event_Group_User_Segments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Segments`)
};

const fr_segment_event_group_user_segments_label = /** @type {(inputs: Segment_Event_Group_User_Segments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segments utilisateur`)
};

const de_segment_event_group_user_segments_label = /** @type {(inputs: Segment_Event_Group_User_Segments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nutzersegmente`)
};

const it_segment_event_group_user_segments_label = /** @type {(inputs: Segment_Event_Group_User_Segments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmenti di utenti`)
};

const ru_segment_event_group_user_segments_label = /** @type {(inputs: Segment_Event_Group_User_Segments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сегменты пользователей`)
};

const es_segment_event_group_user_segments_label = /** @type {(inputs: Segment_Event_Group_User_Segments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentos de usuarios`)
};

const zh_cn2_segment_event_group_user_segments_label = /** @type {(inputs: Segment_Event_Group_User_Segments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户细分`)
};

const ja_segment_event_group_user_segments_label = /** @type {(inputs: Segment_Event_Group_User_Segments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザーセグメント`)
};

const hi_segment_event_group_user_segments_label = /** @type {(inputs: Segment_Event_Group_User_Segments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपयोगकर्ता खंड`)
};

const pt_pt2_segment_event_group_user_segments_label = /** @type {(inputs: Segment_Event_Group_User_Segments_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segmentos de usuários`)
};

/**
* | output |
* | --- |
* | "User Segments" |
*
* @param {Segment_Event_Group_User_Segments_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const segment_event_group_user_segments_label = /** @type {((inputs?: Segment_Event_Group_User_Segments_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Segment_Event_Group_User_Segments_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_segment_event_group_user_segments_label(inputs)
	if (locale === "de") return de_segment_event_group_user_segments_label(inputs)
	if (locale === "it") return it_segment_event_group_user_segments_label(inputs)
	if (locale === "ru") return ru_segment_event_group_user_segments_label(inputs)
	if (locale === "es") return es_segment_event_group_user_segments_label(inputs)
	if (locale === "zh-CN") return zh_cn2_segment_event_group_user_segments_label(inputs)
	if (locale === "ja") return ja_segment_event_group_user_segments_label(inputs)
	if (locale === "hi") return hi_segment_event_group_user_segments_label(inputs)
	if (locale === "pt-PT") return pt_pt2_segment_event_group_user_segments_label(inputs)
	return en_segment_event_group_user_segments_label(inputs)
});